import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const SubHeader = styled.div`
  font-family: ${globals.fontName};
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  color: ${globals.gray800};
  margin-bottom: 24px;
`;

export const ErrorMsg = styled.div`
  color: ${globals.errorText};
  font-size: 14px;
`;

export const ButtonContainer = styled.div`
  margin-top: ${globals.spu};
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
